/**
 * DEPRECATED: This file is maintained for backward compatibility.
 * Please use the centralized configuration instead:
 * 
 * import config from '@/config';
 * or
 * import { env, constants, features } from '@/config';
 */

import config from './config/index';

// Re-export from centralized configuration for backward compatibility
export const API_URL = config.env.API_URL;
export const SUPABASE_URL = config.env.SUPABASE_URL;
export const SUPABASE_ANON_KEY = config.env.SUPABASE_ANON_KEY;
export const NOTION_TOKEN = config.env.NOTION_TOKEN;
export const NOTION_DATABASE_ID = config.env.NOTION_DATABASE_ID;
export const SITE_URL = config.env.SITE_URL;
export const REDIRECT_URL = config.env.REDIRECT_URL;

export const getNotionToken = () => {
  const token = config.env.NOTION_TOKEN;
  if (!token) {
    console.error('❌ Notion token is not configured');
    throw new Error('Notion token is not configured');
  }
  return token;
};

export const siteConfig = {
  siteUrl: config.env.SITE_URL,
  redirectUrl: config.env.REDIRECT_URL
};

// Log deprecation warning in development
if (process.env.NODE_ENV === 'development') {
  console.warn(
    '⚠️ Deprecated: Direct import from src/config.js',
    'Please use src/config/index.js instead'
  );
} 